var _rect, _rect2, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSectionDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.85,
    y: 0.853418,
    width: 40.3,
    height: 40.3,
    rx: 8.15,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.85,
    y: 0.853418,
    width: 40.3,
    height: 40.3,
    rx: 8.15,
    stroke: "#8E9EAB",
    strokeWidth: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.8484 18.144L27.1984 28.214C27.0884 29.784 26.9984 31.004 24.2084 31.004H17.7884C14.9984 31.004 14.9084 29.784 14.7984 28.214L14.1484 18.144",
    stroke: "#F23E2C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 14.9839C26.67 14.6539 23.32 14.4839 19.98 14.4839C18 14.4839 16.02 14.5839 14.04 14.7839L12 14.9839",
    stroke: "#F23E2C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 13.9734L17.72 12.6634C17.88 11.7134 18 11.0034 19.69 11.0034H22.31C24 11.0034 24.13 11.7534 24.28 12.6734L24.5 13.9734",
    stroke: "#F23E2C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSectionDelete);
export default __webpack_public_path__ + "static/media/sectionDelete.871d7d0fbc97bca5c73d01c73e51b1e0.svg";
export { ForwardRef as ReactComponent };